import axios from 'axios';
import { API_BASE_URL } from './config/env.js';

axios.defaults.withCredentials = true;

const getCsrfToken = async () => {
  const response = await axios.get(`${API_BASE_URL}/api/csrf-token/`);
  return response.data.csrfToken;
};

export const appraiseItems = async (items, market = 'jita', save = false, rawInput = '') => {
  const csrfToken = await getCsrfToken();
  const response = await axios.post(`${API_BASE_URL}/api/appraise/`, { 
    items,
    market,
    save,
    rawInput
  }, {
    headers: {
      'X-CSRFToken': csrfToken // Attach token to headers
    }
  });
  return response.data;
};

export const getAppraisal = async (appraisalId) => {
  const [id, params] = appraisalId.split('?');
  const url = `${API_BASE_URL}/api/appraisal/${id}/${params ? '?' + params : ''}`;
  const response = await axios.get(url);
  return response.data;
};

export const getAppraisalCount = async () => {
  const response = await axios.get(`${API_BASE_URL}/api/appraisal-count/`);
  return response.data.count;
};

// New function for comparing markets
export const compareMarkets = async (items, market1 = 'jita', market2 = 'ualx', save = false, rawInput = '') => {
  const csrfToken = await getCsrfToken();
  const response = await axios.post(`${API_BASE_URL}/api/compare/`, {
    items,
    market1,
    market2,
    save,
    rawInput
  }, {
    headers: {
      'X-CSRFToken': csrfToken // Attach token to headers
    }
  });
  return response.data;
};

// Add to api.js
export const getComparison = async (comparisonId) => {
  const [id, params] = comparisonId.split('?');
  const url = `${API_BASE_URL}/api/comparison/${id}/${params ? '?' + params : ''}`;
  const response = await axios.get(url);
  return response.data;
};

// Process items with reprocessing parameters
export const processItems = async (items, market = 'jita', yieldParams = {}, save = false, rawInput = '') => {
  const csrfToken = await getCsrfToken();
  const response = await axios.post(`${API_BASE_URL}/api/process/`, {
    items,
    market,
    yieldParams,
    save,
    rawInput
  }, {
    headers: {
      'X-CSRFToken': csrfToken
    }
  });
  return response.data;
};

// Get a saved processed appraisal by ID
export const getProcessedAppraisal = async (appraisalId) => {
  const [id, params] = appraisalId.split('?');
  const url = `${API_BASE_URL}/api/processed/${id}/${params ? '?' + params : ''}`;
  const response = await axios.get(url);
  return response.data;
};
